// src/App.jsx
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/common/ScrollToTop';
import LoadingSpinner from './components/common/LoadingSpinner';

// Critical path - load immediately for fastest LCP
import HomePage from './components/pages/HomePage';

// Non-critical routes - lazy load for better performance
const BlogListPage = lazy(() => import('./components/pages/BlogListPage'));
const BlogPostPage = lazy(() => import('./components/pages/BlogPostPage'));
const AuthorPage = lazy(() => import('./components/pages/AuthorPage'));
const SeriesListPage = lazy(() => import('./components/pages/SeriesListPage'));
const SeriesPage = lazy(() => import('./components/pages/SeriesPage'));
const NewsletterConfirmPage = lazy(() => import('./components/pages/NewsletterConfirmPage'));
const NewsletterUnsubscribePage = lazy(() => import('./components/pages/NewsletterUnsubscribePage'));
const RSSFeedPage = lazy(() => import('./components/pages/RSSFeedPage'));
const SitemapPage = lazy(() => import('./components/pages/SitemapPage'));
const ForgePage = lazy(() => import('./components/pages/ForgePage'));
const ForgePrivacyPage = lazy(() => import('./components/pages/ForgePrivacyPage'));
const ForgeCliPage = lazy(() => import('./components/pages/ForgeCliPage'));
const GrovePage = lazy(() => import('./components/pages/GrovePage'));
const AgenticSkillsPage = lazy(() => import('./components/pages/AgenticSkillsPage'));
const AgenticSkillsPrivacyPage = lazy(() => import('./components/pages/AgenticSkillsPrivacyPage'));

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/series" element={<SeriesListPage />} />
            <Route path="/blog/series/:seriesName" element={<SeriesPage />} />
            <Route path="/blog/author/:authorSlug" element={<AuthorPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/rss.xml" element={<RSSFeedPage />} />
            <Route path="/sitemap.xml" element={<SitemapPage />} />
            <Route path="/newsletter/confirm" element={<NewsletterConfirmPage />} />
            <Route path="/newsletter/unsubscribe" element={<NewsletterUnsubscribePage />} />
            <Route path="/open-source/forge" element={<ForgePage />} />
            <Route path="/open-source/forge/privacy" element={<ForgePrivacyPage />} />
            <Route path="/open-source/forge-cli" element={<ForgeCliPage />} />
            <Route path="/open-source/grove" element={<GrovePage />} />
            <Route path="/open-source/skillforge" element={<AgenticSkillsPage />} />
            <Route path="/open-source/skillforge/privacy" element={<AgenticSkillsPrivacyPage />} />
          </Routes>
        </Suspense>
      </Router>
    </HelmetProvider>
  );
}

export default App;